module.exports = __webpack_public_path__ + "img/back_1000.b1b7a914.jpg";